import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/products", label: "Products", testid: "nav-products" },
  { to: "/brands", label: "Partner Brands", testid: "nav-brands" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/dealer-network", label: "Dealer Network", testid: "nav-dealers" },
  { to: "/news", label: "News", testid: "nav-news" },
  { to: "/support", label: "Support", testid: "nav-support" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/90 backdrop-blur-xl transition-colors duration-300">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3">
          <img
            src="/logo.png"
            alt="Runner Trade Park Limited"
            className="h-[77px] w-auto rounded-lg bg-white p-1"
          />
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              end={l.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-bold tracking-wide transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <button
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            className="flex h-10 w-10 items-center justify-center border-2 border-border text-foreground lg:hidden"
            aria-label="Menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-border bg-background lg:hidden" data-testid="mobile-nav">
          <div className="flex flex-col px-4 py-2">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `border-b border-border/50 py-3 text-sm font-bold tracking-wide ${
                    isActive ? "text-primary" : "text-foreground"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
